<template>
  <div id="select-company">
    <v-row align="center" justify="center">
      <v-col cols="12" md="5">
          <v-list-item v-for="company in companies" :key="company.companyID" link
                       :to="`${company.companyID}/dashboard`">
            <v-list-item-icon>
              <v-avatar size="30" color="#F5F5F5" class="m-0" style="background-color: #fff;">
                <img v-if="company.company.imageLogoUrl" :src="company.company.imageLogoUrl + '=s' + Math.round(30 * getDeviceRatio())"
                     :alt="company.company.nameTH" style=" object-fit: contain;">
                <span v-else-if="company.company.nameEN"
                      class="edit-text-avatar">{{ company.company.nameEN[0].toUpperCase() }}</span>
                <span v-else/>
              </v-avatar>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ company.company.nameTH }}</v-list-item-title>
            </v-list-item-content>
             <v-list-item-icon>
              <v-icon>mdi-chevron-right</v-icon>
            </v-list-item-icon>
          </v-list-item>
      </v-col>
    </v-row>
    <v-row style="padding-bottom: 100px" class="d-flex justify-center mt-5" >
      <router-link v-bind:to="'/company-add'" class="button-create">
        <button class="tw-mr-5 hover:tw-bg-light-green hover:tw-bg-opacity-10 tw-font-bold tw-py-2 tw-px-6 tw-rounded-lg">
          <img src="/images/icons/icon_add_company.svg" alt="add-company" class="tw-float-left tw-w-5 tw-mr-2"/>
          เพิ่มบริษัทของคุณ
        </button>
      </router-link>
      <router-link v-bind:to="'/company-add-with-code'" class="button-create">
        <button class="tw-mr-5 hover:tw-bg-light-green hover:tw-bg-opacity-10 tw-font-bold tw-py-2 tw-px-6 tw-rounded-lg">
          <img src="/images/icons/icon_add.svg" alt="add-company" class="tw-float-left tw-w-5 tw-mr-2"/>
          เพิ่มบริษัทด้วยโค้ด
        </button>
      </router-link>
    </v-row>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "selectCompany",
  computed: mapState({
    companies: state => state.companies.list,
  }),
  created() {
    this.$store.dispatch('companies/getList')
  },
  methods: {
    getDeviceRatio() {
      return window.devicePixelRatio
    },

  }
}
</script>

<style lang="scss">
* {
  font-family: "Noto Sans Thai", "Noto Sans", sans-serif;
}

.register-logo {
  width: 100px;
  display: block;
  margin: 20px auto;
}

#select-company {
  .v-list-item {
    border-bottom: 1px solid #c4c4c4;
  }

  .button-create {
    text-decoration: none !important;
    margin-right: 10px;
  }
}

</style>
